import confirmation from "../../../../../../image/goods.image/humates/confirmation2.jpg";

export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Екологічно чиста високоефективна добавка для ґрунту, яка допомагає відновити його родючість та забезпечує здоровий ріст рослин.
                </p>
                <p className="card__description-text">
                    Біочар IDEALE™ — це натуральний продукт, створений за спеціальною запатентованою технологією. Він покращує структуру ґрунту, утримує вологу та поживні речовини, сприяючи активному розвитку кореневої системи та загальному зміцненню рослин.
                </p>
                <p className="card__description-title">
                    Основні переваги:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            Забезпечує високу схожість насіння
                        </li>
                        <li className="card__description-numbering">
                            Прискорює проростання та ріст рослин
                        </li>
                        <li className="card__description-numbering">
                            Сприяє формуванню потужної кореневої системи
                        </li>
                        <li className="card__description-numbering">
                            Підвищує імунітет рослин
                        </li>
                        <li className="card__description-numbering">
                            Пригнічує розвиток шкідливої мікрофлори
                        </li>
                        <li className="card__description-numbering">
                            Покращує структуру ґрунту та його родючість на роки
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Особливості:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            Виготовлений із натуральної біомаси методом гідротермальної карбонізації
                        </li>
                        <li className="card__description-numbering">
                            Зберігає свої властивості в ґрунті десятиліттями
                        </li>
                        <li className="card__description-numbering">
                            Допомагає рослинам отримувати поживні речовини без додаткових добрив
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Склад і характеристики:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            Вуглець: 92–96%
                        </li>
                        <li className="card__description-numbering">
                            Гумінові речовини: 28,8–32,2%
                        </li>
                        <li className="card__description-numbering">
                            Азот (N): 0,2–0,47%
                        </li>
                        <li className="card__description-numbering">
                            Фосфор (P): 0,41–0,43%
                        </li>
                        <li className="card__description-numbering">
                            Калій (K): 0,11–0,16%
                        </li>
                        <li className="card__description-numbering">
                            pH: 6,5–7,2
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Ідеально підходить для:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            кімнатних рослин
                        </li>
                        <li className="card__description-numbering">
                            розсади овочів
                        </li>
                        <li className="card__description-numbering">
                            квітів у горщиках
                        </li>
                        <li className="card__description-numbering">
                            тепличного вирощування
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Біочар IDEALE™ — оживіть ґрунт і побачте, як рослини ростуть на очах!
                </p>
                <p className="card__description-text">
                    Ваші рослини перестали рости? Розсада слабка, а ґрунт «виснажений»? Є просте рішення — Біочар IDEALE™.
                </p>
                <p className="card__description-text">
                    Це не просто добавка — це потужний природний стимулятор, який повертає ґрунту життя і дає рослинам усе необхідне для швидкого та здорового росту.
                </p>
                <p className="card__description-title">
                    Що ви отримаєте вже після першого використання:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            швидше проростання насіння
                        </li>
                        <li className="card__description-numbering">
                            міцну та розвинену кореневу систему
                        </li>
                        <li className="card__description-numbering">
                            насичений колір і здоровий вигляд рослин
                        </li>
                        <li className="card__description-numbering">
                            менше проблем із хворобами та грибками
                        </li>
                        <li className="card__description-numbering">
                            довготривалий ефект без постійних підживлень
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Чому обирають саме IDEALE™:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            Працює роками, а не тижнями
                        </li>
                        <li className="card__description-numbering">
                            Утримує вологу — менше поливу, більше користі
                        </li>
                        <li className="card__description-numbering">
                            Поглинає та поступово віддає поживні речовини
                        </li>
                        <li className="card__description-numbering">
                            Повністю натуральний та безпечний
                        </li>
                        <li className="card__description-numbering">
                            Ідеально підходить навіть для кімнатних рослин
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Уявіть:
                </p>
                <p className="card__description-text">
                    Ваша розсада росте рівномірно та швидко, квіти стають яскравішими, а ґрунт більше не «втомлюється» з сезону в сезон.
                </p>
                <p className="card__description-title">
                    Формат:
                </p>
                <p className="card__description-text">
                    Зручна упаковка 1,5 л — вистачить для старту і ви одразу побачите результат.
                </p>
                <p className="card__description-title">
                    Результат, який помітно:
                </p>
                <p className="card__description-text">
                    Біочар IDEALE™ не маскує проблему — він відновлює ґрунт зсередини, створюючи ідеальні умови для росту.
                </p>
                <p className="card__description-text">
                    Спробуйте один раз — і ваші рослини самі покажуть різницю.
                </p>
                <p className="card__description-title">
                    Норма внесення біочару IDEALE™ для розсади та квітів
                </p>
                <p className="card__description-text">
                    Щоб отримати максимальний ефект, важливо правильно додавати біочар у ґрунт:
                </p>
                <p className="card__description-title">
                    Для розсади
                </p>
                <p className="card__description-text">
                    Приклад: на 1 л ґрунту — 100–200 мл біочару
                </p>
                <p className="card__description-title">
                    Рекомендація:
                </p>
                <p className="card__description-text">
                    перед використанням бажано зволожити або змішати біочар із компостом чи добривом для кращого старту.
                </p>
                <p className="card__description-title">
                    Для кімнатних квітів:
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        10–15% від об’єму ґрунту
                    </li>
                </ul>
                <p className="card__description-text">
                    При пересадці:
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        додати в новий ґрунт і добре перемішати
                    </li>
                </ul>
                <p className="card__description-text">
                    Для вже висаджених рослин:
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        внести 1–2 столові ложки на горщик (залежно від розміру)
                    </li>
                    <li className="card__description-numbering">
                        акуратно перемішати з верхнім шаром ґрунту та полити
                    </li>
                </ul>
                <p className="card__description-title">
                    Висновок
                </p>
                <p className="card__description-text">
                    Біочар — це природний інструмент, який допомагає виростити сильну, здорову та витривалу розсаду. Завдяки своїй пористій структурі та високому вмісту корисних речовин, він створює оптимальне середовище для формування потужної кореневої системи — основи майбутньої рослини.
                </p>
                <div className="biochar_confirmation">
                    <img src={confirmation} alt="Підтвердження" />
                </div>
            </div>
            <div className="card__reference-preference">
                <div className="aside__title--new">Унікальні властивості</div>
                <div className="asede__head">
                    <div className="aside__block">збільшує доступність в грунтах кальція (Са), магнія (Mg), фосфора (Р) та калія (К);</div>
                    <div className="aside__block">Сприяє розвитку корисних мікроорганізмів, зберігає і підтримує поживні речовини і необхідні мікроелементи в грунті усуває проблему їх вимивання;</div>
                    <div className="aside__block">поліпшує структуру грунту, робить його пористим, затримує вологу, забезпечує доступ кисню до кореневої системи;</div>
                    <div className="aside__block">запобігає злипанню землі в грудки;</div>
                    <div className="aside__block">стимулює злипанню землі в грудки;</div>
                    <div className="aside__block">нейтралізує кисні грунти;</div>
                    <div className="aside__block">запобігає появі шкідників, є проти паразитним і антибактеріальним засобом;</div>
                    <div className="aside__block">перешкоджає розвитку гнильних процесів;</div>
                    <div className="aside__block">транспортний шлях для мікоризи і бакетерій (грибниці, яка розвивапється на кореневій системі);</div>
                    <div className="aside__block">збільшеє ефективність добрив;</div>
                    <div className="aside__block">має проллонговану дію;</div>
                </div>
            </div>
        </div>
    );
}
